import { dateFormatter } from "project-config/utils/date-formatter";
import { useTranslation } from "react-i18next";

export function useGetInvoiceHistoryRecordTable() {
  const { t } = useTranslation("invoice");
  const columns = [
    {
      title: t("invoice_invoice_creatme_time"),
      dataIndex: "createDate",
      key: "createDate",
      render: (row: number) => dateFormatter(row),
    },
    {
      title: t("invoice_invoice_create_type"),
      dataIndex: "type",
      key: "type",
      render: (row: number) => t(`invoice_invoice_type_arr_${row}`),
    },
    {
      title: t("invoice_invoice_create_money"),
      dataIndex: "money",
      key: "money",
    },
    {
      title: t("invoice_detail_invoice"),
      dataIndex: "title",
      key: "title",
    },
    {
      title: t("invoice_mailing_information"),
      dataIndex: "handle",
      key: "handle",
      render: (_: any, row: any) => {
        let text = "----";
        if (row.expressCompany && row.expressNumber) {
          text = `${row.expressCompany} ${row.expressNumber}`;
        }
        return <span style={{ color: "var(--main-color)" }}>{text}</span>;
      },
    },
    {
      title: t("invoice_invoice_state"),
      dataIndex: "status",
      key: "status",
      render: (_: any, row: any) => {
        if ([3, 5, 7, 9].includes(row.status)) {
          return (
            t(`invoice_history_status_${row.status}`) +
            (row.remarks ? `(${row.remarks})` : "")
          );
        }
        return t(`invoice_history_status_${row.status}`);
      },
    },
  ];
  return columns;
}
